module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/117biPB/images/e9781439633151_cover.jpg?1684514597754",
      "alt": "This image is the cover for the book Rogers, Hassan Township, and Fletcher Remembered, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rogers, Hassan Township, and Fletcher Remembered, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The heavily wooded area of western Hennepin County, known as the \"Big Woods\" to early explorers, slowly transformed into three trade centers with the first permanent settlers staking their claims to land in 1854. The initial pioneers emigrated from such faraway places as Germany, Ireland, England, and France in search of a better life, and the fact that many of their ancestors still reside in the area demonstrates they found just that. Rogers, Hassan Township, and Fletcher Remembered is a photographic tour of three early trade centers that formed a community. The pictures, newspaper clippings, and stories provided by local residents and businesses capture the rich history of the area and illustrate how emphasis on church, education, commerce, and entertainment created the endless opportunities enjoyed today.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paulie Skaja-Bell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Paulie Skaja-Bell has lived in Rogers since 1995. In 11 short years, she has helped form a volunteer organization, assisted with founding a charter school, and currently serves on the boards of multiple volunteer organizations in the community. Professionally, she provides marketing and career coaching for clients.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0